"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Directive, ElementRef, Input, NgZone, Optional, Renderer2, Self, } from '@angular/core';
import { LayoutGapDirective as FlexLayoutLayoutGapDirective, MediaMonitor, } from '@angular/flex-layout';
import { LayoutDirective } from './layout.directive';
function convertGapSize(size) {
    switch (size) {
        case 'xxxsmall':
            return '4px';
        case 'xxsmall':
            return '8px';
        case 'xsmall':
            return '12px';
        case 'small':
            return '16px';
        case 'mid':
            return '24px';
        case 'large':
            return '32px';
        case 'xlarge':
            return '48px';
        case 'xxlarge':
            return '64px';
        case 'xxxlarge':
            return '72px';
        case 'xxxxlarge':
            return '96px';
        default:
            return '0';
    }
}
var LayoutGapDirective = (function (_super) {
    __extends(LayoutGapDirective, _super);
    function LayoutGapDirective(monitor, elementRef, renderer, container, zone) {
        return _super.call(this, monitor, elementRef, renderer, container, zone) || this;
    }
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGap", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gap', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapMobile", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapMobile', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapTablet", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapTablet', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapDesktopSmall", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapDesktopSmall', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapDesktopLarge", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapDesktopLarge', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapDesktopXLarge", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapDesktopXLarge', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "layoutGapDesktopXXLarge", {
        set: function (val) {
            var pixelValue = convertGapSize(val);
            this._cacheInput('gapDesktopXXLarge', pixelValue);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayoutGap'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGap", null);
    __decorate([
        Input('flLayoutGap.mobile'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapMobile", null);
    __decorate([
        Input('flLayoutGap.tablet'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapTablet", null);
    __decorate([
        Input('flLayoutGap.desktop-small'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapDesktopSmall", null);
    __decorate([
        Input('flLayoutGap.desktop-large'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapDesktopLarge", null);
    __decorate([
        Input('flLayoutGap.desktop-xlarge'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapDesktopXLarge", null);
    __decorate([
        Input('flLayoutGap.desktop-xxlarge'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LayoutGapDirective.prototype, "layoutGapDesktopXXLarge", null);
    LayoutGapDirective = __decorate([
        Directive({
            selector: "\n    [flLayoutGap],\n    [flLayoutGap.mobile],\n    [flLayoutGap.tablet],\n    [flLayoutGap.desktop-small],\n    [flLayoutGap.desktop-large],\n    [flLayoutGap.desktop-xlarge],\n    [flLayoutGap.desktop-xxlarge],\n  ",
        }),
        __param(3, Optional()),
        __param(3, Self()),
        __metadata("design:paramtypes", [MediaMonitor,
            ElementRef,
            Renderer2,
            LayoutDirective,
            NgZone])
    ], LayoutGapDirective);
    return LayoutGapDirective;
}(FlexLayoutLayoutGapDirective));
export { LayoutGapDirective };



// WEBPACK FOOTER //
// layout-gap.directive.js